package com.tixforgigs.common.core.models.embed

import kotlinx.serialization.Serializable

@OptIn(ExperimentalJsExport::class)
@Serializable
data class PostMessageEmbedActiveCartItemsCountDTO(
  val activeCartItemsCount: Int
)
